import styled from 'styled-components'

export const H1 = styled.div`
  font-family: Inter, sans-serif;
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
`

export const H3 = styled.div`
  font-family: Inter, sans-serif;
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
`

export const H4 = styled.div`
  font-family: Inter, sans-serif;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
`

export const H5 = styled.div`
  font-family: Inter, sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
`

export const Subheading = styled.div`
  font-family: Inter, sans-serif;
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
`

type Type = 'h1' | 'h3' | 'h4' | 'h5' | 'sub'
type HeadingComponent = typeof H1
type HeadingProps = React.ComponentProps<HeadingComponent> & { type: Type }

const Components: Record<Type, HeadingComponent> = {
  h1: H1,
  h3: H3,
  h4: H4,
  h5: H5,
  sub: Subheading
}

export const Heading: React.FC<HeadingProps> = ({ type, ...rest }) => {
  const Component = Components[type]
  return Component ? <Component {...rest} /> : null
}
